import React, { Component } from 'react';
import Select from 'react-select';
import { ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {  Label } from 'reactstrap';
import CSVIcon from '../Images/csv-ico.png';
import PositionsFile from '../Resources/Example of Positions.csv';
import Checkbox from '@material-ui/core/Checkbox';
import PositionService  from '../Services/PositionService/positionService';
import { css } from 'react-emotion';
import Radio from '@material-ui/core/Radio';
import {  Redirect } from 'react-router-dom';
// First way to import
import { ClipLoader } from 'react-spinners';
var base64 = require('base-64');

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
const scrollTable = {
    'height': '100px',
    'overflowY': 'scroll'
}

class PositionsImportFile extends Component{

    constructor(props){
        super(props);
        this.state = {
            PositionList: { pennding:false, value: []},
            PositionUpList: { pennding:false, value: []},
            HeadersList: [],
            error: null,
            checkboxOptions: [],
            CompanyCode: "",
            Selected: false,
            loading: false,
            AddButton: "",
            selectedValue: '2',
            Headers: false,
            HPositionName: false,
            HPositionDescription: false,
            UploadFileName: "Choose File",
            isAutenticated: true
        };
        this.handleData = this.handleData.bind(this);
        this.SelectedAll = this.SelectedAll.bind(this);
        this.onChange = this.onChange.bind(this);
    } 
    handleData(e) {
        var uploadedFile = e.target.files[0];
        var name = e.target.files[0] ?  e.target.files[0].name : "Choose File";
        var extFile = e.target.files[0].name.split('.').pop();

        this.setState({
            PositionUpList: { pennding: true, value: [] },
            HeadersList: [],
            Headers: false
        });             
        if(uploadedFile){
            if(extFile.toUpperCase() !== "CSV")
            {
                toast.error("File has to be a .CSV!", {
                    className: {
                        opacity: 0.8
                    }
                });
                return false;
            }
        let reader = new FileReader();    
        reader.onload = (progressEvent) => {
            //let target = progressEvent.target; 
            //let result = target.result;               
            var base64result = reader.result.split(',')[1];
            var encoded = base64.decode(base64result);
            var data = encoded.split('\n');
            var DataList = [];
            data.forEach(element => {
                DataList.push(element.split(','));                
            });
            //console.log(DataList)

              //console.log(DataList)
              var PositionName = "";
              var PositionDescription = "";
              DataList[0].forEach(function(element) {
  
                  if(element.replace(/\s/g, "").toUpperCase() === "POSITIONNAME"){
                      
                    PositionName = element;
                  }else if(element.replace(/\s/g, "").toUpperCase() === "POSITIONDESCRIPTION"){
  
                    PositionDescription = element;
                  }
                });
            this.setState({
                PositionUpList: { pennding: true, value: DataList},
                HeadersList: DataList[0],
                Headers: true,
                UploadFileName: name,
                HPositionName: { value: PositionName , label: PositionName},
                HPositionDescription: { value: PositionDescription , label: PositionDescription}
            });    
          };    
          reader.readAsDataURL(uploadedFile); 
        }else{
            this.setState({
                PositionUpList: { pennding: true, value: []},
                HeadersList: [],
                Headers: true,
                UploadFileName: "Choose File"
            });   
        } 
    } 
    handleHPositionName = event => {
        this.setState({
            HPositionName: event
        });
    }
    handleHPositionDescription = event => {
        this.setState({
            HPositionDescription: event
        });
    }
    UploadLocationList(e) {
        e.preventDefault();
        var ActionType = this.state.selectedValue;
        var DataList = this.state.PositionUpList.value;
        var HeaderListist = this.state.HeadersList;
        var HeaderPsotionName = this.state.HPositionName.value;
        var HeaderPositionDescription = this.state.HPositionDescription.value;
        var Result = [];

        var positionPositionName = HeaderListist.indexOf(HeaderPsotionName);
        var positionPositionDescription = HeaderListist.indexOf(HeaderPositionDescription);

        if (positionPositionName === -1) {
            toast.error("Position Name field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        var Description = "";
        for (var i = 1; i < (DataList.length - 1); i++) {
            if (DataList[i] !== "") {
                if(positionPositionDescription === -1)
                  Description = "";
                else
                 Description =  DataList[i][positionPositionDescription];  

                Result.push({ POSITION_NAME: DataList[i][positionPositionName], POSITION_DESCRIPTION: Description });
            }
        }
         if(DataList === "" || DataList === null || DataList === undefined || DataList.length === 0){
 
            toast.error("You must to select a File!", { className: {
                opacity: 0.8
            }}); 
        }else{ 
            if(this.props.CompanyCode && DataList){ 
                this.setState({
                    PositionList: { pennding: true, value: [] }
                });      
                var ListResult =  PositionService.getPositionListResult(this.props.CompanyCode, Result, ActionType); 
                var that = this; 
                ListResult.then(function (data) { 
                    if(data.statusText === "OK")
                    {                
                        that.setState({
                            PositionList: { pennding: false, value: data.data },
                            checkboxOptions: [],
                        });
                    } 
                }).catch((error) => { 
                      
                        that.setState({
                            PositionList: { pennding: false, value: [] },
                            checkboxOptions: [],
                        });

                        if(error.response)
                        {
                            if(error && error.response && error.response.data.Message === "500") {               
                                toast.error("Error Data Base(Error: 500)", { className: {
                                   opacity: 0.8
                               }});
                           }else if(error && error.response && error.response.data === "NoDB") {
                               toast.error("Company Code dosen't exist!", { className: {
                                   opacity: 0.8
                               }});
                           }else if(error && error.response && error.response.data === "NotReseller") {    
                               toast.error("This User does not have permission!", { className: {
                                   opacity: 0.8
                               }});
                           }else if(error && error.response && error.response.data.Message === "400"){ 
                               toast.error("API Error for Reseller", { className: {
                                   opacity: 0.8
                               }});
                            }else if(error.response.status === 401){ 
                                   sessionStorage.setItem("user", '');
                                   sessionStorage.setItem("token", '');
                                   sessionStorage.setItem("rol", '');
                                   sessionStorage.setItem("email", '');
                                   sessionStorage.clear();  
                                   this.setState({ isAutenticated: false },
                                   ()=>{                               
                                       this.forceUpdate();
                                   })              
                            }   
                        }else{
                            toast.error("Code Error", { className: {
                                opacity: 0.8
                            }});
                        }
                });
            }  
        }       
    }
    handleChange = event => { 
        this.setState({
            selectedValue: event.target.value,
            PositionList: { pennding: false, value: [] }
       });      
    }
    onChange(e, code) {     
        const options = this.state.checkboxOptions
        let index;    
        if (!options.find(x=>x===code)) {
          options.push(code)
        } else {
          index = options.indexOf(code)
          options.splice(index, 1)
        }
        this.setState({ checkboxOptions: options }, console.log())
    }
    SelectedAll(e){
        if(e.target.checked){
            let optionChecked = [];
             this.state.PositionList.value.forEach(l=>{
                  if(l.AVAILABLE)
                  optionChecked.push(l.POSITION_NAME);
             })
             this.setState({checkboxOptions:optionChecked})
        }
        else{
            this.setState({checkboxOptions:[]})
        }          
    }
    SavePositionList(e){
        e.preventDefault();
        var CheckboxList = this.state.checkboxOptions; 
        var email = sessionStorage.getItem('email');
        var ActionType = this.state.selectedValue;
        var result = [];  
        var that = this; 
        that.setState({
            loading: true,
            AddButton: "disabled"
        });        
        if(CheckboxList.length === 0 || ActionType === "" || ActionType === undefined || ActionType === null)
        {
            toast.error("You must to select a Position and Option Rows!", { className: {
                opacity: 0.8
            }});            
            that.setState({
                loading: false,
                AddButton: ""
            });
        }else{
            CheckboxList.forEach(l =>{               
               var position = this.state.PositionList.value.find(x=>x.POSITION_NAME === l);
               result.push(position);
           });
           var DataResult = PositionService.SavePosition(this.props.CompanyCode, result, ActionType, email);
           DataResult.then(function (data) {      
               if(data.data === "OK")
               {                
                   that.setState({
                       loading: false,
                       PositionList: { pennding: false, value: [] },
                       checkboxOptions: [],
                       AddButton: "",
                       CompanyCode: "",
                   });
                   toast.success("Positions Saved!", { className: {
                       opacity: 0.8
                   }});
               }else if(data.statusText === "No")
               {                
                   that.setState({
                       loading: false,
                       PositionList: { pennding: false, value: [] },
                       checkboxOptions: [],
                       AddButton: "",
                       CompanyCode: "",
                   });
                   toast.error("No Saved!", { className: {
                       opacity: 0.8
                   }});
               }else if(data.data === "InUse")
               {                
                    that.setState({
                        loading: false,
                        PositionList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: "",
                    });
                   toast.error("Position Code in Use!", { className: {
                       opacity: 0.8
                   }});
               }else if(data.statusText === "AuditError")
               {                
                   that.setState({
                       loading: false,
                       PositionList: { pennding: false, value: [] },
                       checkboxOptions: [],
                       AddButton: "",
                       CompanyCode: "",
                   });
                   toast.error("No Saved!", { className: {
                       opacity: 0.8
                   }});
               }
           }).catch((error) => {   
                   
                   that.setState({
                    loading: false,
                    PositionList: { pennding: false, value: [] },
                    checkboxOptions: [],
                    AddButton: "",
                    CompanyCode: "",
                });
                if(error.response)
                {
                    if(error && error.response && error.response.data.Message === "500") {               
                        toast.error("Error Data Base(Error: 500)", { className: {
                           opacity: 0.8
                       }});
                   }else if(error && error.response && error.response.data === "NoDB") {
                       toast.error("Company Code dosen't exist!", { className: {
                           opacity: 0.8
                       }});
                   }else if(error && error.response && error.response.data === "NotReseller") {    
                       toast.error("This User does not have permission!", { className: {
                           opacity: 0.8
                       }});
                   }else if(error && error.response && error.response.data.Message === "400"){ 
                       toast.error("API Error for Reseller", { className: {
                           opacity: 0.8
                       }});
                    }else if(error.response.status === 401){ 
                           sessionStorage.setItem("user", '');
                           sessionStorage.setItem("token", '');
                           sessionStorage.setItem("rol", '');
                           sessionStorage.setItem("email", '');
                           sessionStorage.clear();  
                           this.setState({ isAutenticated: false },
                           ()=>{                               
                               this.forceUpdate();
                           })              
                    }   
                }else{
                    toast.error("Code Error", { className: {
                        opacity: 0.8
                    }});
                }
           });
        }       
    }
    changeName(e){
        //alert(e.target.value)
        var str = e.target.value;
        var res = str.substring(12)
        var extention = res.split('.').pop();
        if(extention.toUpperCase() === "CSV")
        {
            this.setState({
                FileName: res 
            });
        }else{
            this.setState({
                FileName: "CHOOSE A FILE",
                PositionUpList: { pennding: false, value: [] },
            });
            toast.error("File Error!", { className: {
                opacity: 0.8
            }});
            return false;
        }  
        return true;    
    }
    render(){              
       
        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'}/>)
        }
        
        let optionItemsHeaders = this.state.HeadersList.map((item, index) => {
            return {value: item, label: item}
        });
        return (
            <div>
                <div className="card Logs"><ToastContainer hideProgressBar/>
                    <div className="card-body">
                    <div className="row">
                            <div className="col-2">
                                <h4><span className="badge badge-info">Positions</span></h4>
                            </div>                          
                            <div className="col-2 offset-10">
                                <Label for="exampleFile" style={{ 'fontWeight': 'bold' }}>Download Sample</Label>
                                <a href={PositionsFile} download="Example of Positions.CSV"><img src={CSVIcon} title="NotImage" alt="" width='40px' /></a>
                            </div>
                    </div>
                    <div className="row">
                        <div className="col-3 offset-2">
                        {
                            this.props.CompanyCode
                            &&
                            <div className="upload-btn-wrapper" key={Math.random()*1200000}>
                                <button style={{ 'width' : '100%', 'backgroundColor': '#00C851', 'marginLeft': '0px'}} onClick={(e)=>this.fileInput.click(e)}  className="btn btn-primary">{this.state.UploadFileName}</button>
                                <input  ref={input =>this.fileInput = input } type="file" name="myfile" style={{'display': 'none'}}  onChange={ (event)=>{this.handleData(event)}}/>                                   
                            </div>
                        }
                        </div>
                        <div className="col-2">
                            {
                                this.props.CompanyCode
                                &&
                                <div >
                                    <label>Delete Rows in Table</label>
                                    <Radio
                                        checked={this.state.selectedValue === '1'}
                                        onChange={this.handleChange}
                                        value="1"
                                        name="radio-button-demo"
                                        aria-label="A"
                                        color="primary"
                                    />
                                </div>
                            }
                        </div>
                        <div className="col-3">
                            {
                                this.props.CompanyCode
                                &&
                                <div >
                                    <label>Appends Rows in Table</label>
                                    <Radio
                                        checked={this.state.selectedValue === '2'}
                                        onChange={this.handleChange}
                                        value="2"
                                        name="radio-button-demo"
                                        aria-label="B"
                                        color="primary"
                                    />
                                </div>
                            }
                        </div>

                    </div>
                    <br /> <br />
                    {
                        this.state.Headers
                        &&
                        <div className="row">
                            <div className="col-2 offset-3">
                                <div className="form-group">
                                    <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block"}} >Position Name(<span style={{color: 'red'}}>*</span>):</label>
                                    <Select
                                        value={this.state.HPositionName}
                                        onChange={this.handleHPositionName}
                                        options={optionItemsHeaders}
                                        styles={{  width: "10px"}}
                                    />
                                </div>
                            </div>
                            <div className="col-2">
                                <div className="form-group">
                                    <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block"}} >Position Description(<span style={{color: 'red'}}>*</span>):</label>
                                    <Select
                                        value={this.state.HPositionDescription}
                                        onChange={this.handleHPositionDescription}
                                        options={optionItemsHeaders}
                                        styles={{  width: "10px"}}
                                    />
                                </div>
                            </div>
                            <div className="col-2 offset-3">
                                <div className="form-group" style={{ paddingTop: '28px'}}>
                                    <button className="btn btn-info" onClick={(e) => { this.UploadLocationList(e) }} >Preview</button>
                                </div>
                            </div>
                        </div>
                    }
                    </div>
                </div>
                    {
                         (this.state.PositionList.pennding
                         && <span className="loader"></span>)
                         ||
                        (this.state.PositionList.value.length > 0 
                        && <div className="card Logs">
                             <div className="card-body">
                                <div className="row" style={{'height': '350px', 'overflow': 'auto'}}>
                                <table className="table table-hover table-striped table-sm" >
                                            <thead>
                                                <tr>
                                                    <th scope="col">
                                                    <Checkbox
                                                        style={{ width: 25, height: 25 }}
                                                        // checked={this.state.Selected}
                                                        onChange={this.SelectedAll}
                                                        //value={this.state.checkboxOptions}
                                                        color="primary"
                                                        />
                                                    </th>
                                                    <th scope="col">Employee Position Name</th>
                                                    <th scope="col">Employee Position Description</th>                                               
                                                </tr>
                                            </thead>
                                            <tbody style={scrollTable}>
                                                {
                                                    (this.state.PositionList.pennding
                                                    && <tr><td colSpan="7"><span className="loader"></span></td></tr>)
                                                    || this.state.PositionList.value.map((item, index) => {
                                                        
                                                        return <tr key={index}>
                                                            <td>
                                                                {
                                                                    (item.AVAILABLE 
                                                                    && 
                                                                        <Checkbox
                                                                        style={{ width: 25, height: 25 }}
                                                                        checked={this.state.checkboxOptions.find(x=>x === item.POSITION_NAME)!== undefined }
                                                                        onChange={(e)=>this.onChange(e,item.POSITION_NAME)}
                                                                        value= {item.POSITION_NAME}
                                                                        color="primary"
                                                                     />)
                                                                     || 
                                                                      <span className="badge badge-danger">{item.AVAILABLE_MSG}</span>
                                                                }
                                                               
                                                            </td>
                                                            <td>{item.POSITION_NAME}</td>
                                                            <td>{item.POSITION_DESCRIPTION}</td>
                                                        </tr>;
                                                    })
                                                }
                                            </tbody>
                                    </table>                                     
                                </div>
                                <div className="row">
                                    <div className="col-2 offset-10">
                                        <ClipLoader
                                            className={override}
                                            sizeUnit={"px"}
                                            size={30}
                                            color={'#33B5E5'}
                                            loading={this.state.loading}
                                        />
                                        <button disabled={this.state.AddButton} className="btn btn-info" onClick={(e)=>{this.SavePositionList(e)}} >Save</button>
                                    </div>
                                </div>                                                              
                             </div>
                        </div>)    
                    }    
            </div>            
        );
    }
}

export default PositionsImportFile;


// WEBPACK FOOTER //
// ./src/ImportFile/PositionsImportfile.jsx